// import React from "react";
// import { GrFacebookOption, GrInstagram } from "react-icons/gr";
// import { FaTwitter, FaYoutube, FaLinkedinIn } from "react-icons/fa";
// import KaasLogo from "../TmsImages/Kaas_logo.jpg";
// import google from "../Images/google.png";
// import KaasLogow from "../Images/Vetrina _Logo.png";

// import iphone from "../Images/apple.png";
// import "../Styles/Footer.css";
// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
    
//     <footer className="footer">
//       <div className="footer-container">
//         {/* Column 1 */}
//         <div className="footer-column">
//           <p className="footer-description">
//            Punyai Pride,shivshambho nagar lane no.3A,Katraj Kondhawa,Pune 411046.Maharashtra,India
//           </p>
//         </div>

//         {/* Column 2 */}
//         <div className="footer-column">
//           <h4 className="footer-heading">Contact Us</h4>
//           <p className="footer-contact">vetlearn@vetrinahealthcare.com</p>
//           <p className="footer-contact">+91 8600844450 |+91 9823557377</p>
//           <div className="footer-social-icons">
//             <a href="https://www.facebook.com/vetrinahealthcareenglish" className="social-icon"><GrFacebookOption /></a>
//             <a href="https://www.instagram.com/vetrinahealthcareenglish/" className="social-icon"><GrInstagram /></a>
//             <a href="https://x.com/VetrinaPune%22" className="social-icon"><FaTwitter /></a>
//             <a href="https://www.youtube.com/channel/UCJ3r6VSr5EnxoKEQjYZoWIA" className="social-icon"><FaYoutube /></a>
//             <a href="https://www.linkedin.com/company/14518974%22" className="social-icon"><FaLinkedinIn /></a>
//           </div>
//           <h5 className="footer-subheading">Quick Links</h5>
//           <ul className="footer-links">
//             <li><a href="/">Privacy Policy</a></li>
//             <li><a href="/">Terms & Conditions</a></li>
//           </ul>
//         </div>

//         {/* Column 3 */}
//         <div className="footer-column">
//           <h4 className="footer-heading">Available On</h4>
//           <div className="footer-apps">
//             <img src={google} alt="Google Play" />
//             <img src={iphone} alt="Apple Store" />
//           </div>

//           <h5 className="footer-subheading">Subscribe to Newsletter</h5>
//           <form onSubmit={(e) => e.preventDefault()} className="newsletter-form">
//             <input
//               type="email"
//               placeholder="Enter your email"
//               required
//             />
//             <button type="submit">Submit</button>
//           </form>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         © {currentYear} Vetrina. All rights reserved. Designed & Maintained by{" "}
//         <a href="https://vetrinahealthcare.com/" target="_blank" rel="noreferrer">
//           Vetrina Healthcare Pvt Ltd
//         </a>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import { GrFacebookOption, GrInstagram } from "react-icons/gr";
import { FaTwitter, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";
import google from "../Images/google.png";
import iphone from "../Images/apple.png";
import "../Styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Column 1: Contact Us */}
        <div className="footer-column">
          <h4 className="footer-heading">Contact Us</h4>
          <p className="footer-contact">
            <MdLocationOn className="footer-icon" />
            Punyai Pride, Shivshambho Nagar Lane No.3A,
            Katraj Kondhwa Road, Pune 411046, Maharashtra, India
          </p>
          <p className="footer-contact">
            <MdEmail className="footer-icon" /> vetlearn@vetrinahealthcare.com
          </p>
          <p className="footer-contact">
            <MdPhone className="footer-icon" /> +91 8600844450 | +91 9823557377
          </p>
          <div className="footer-social-icons">
            <a href="https://www.facebook.com/vetrinahealthcareenglish" className="social-icon">
              <GrFacebookOption />
            </a>
            <a href="https://www.instagram.com/vetrinahealthcareenglish/" className="social-icon">
              <GrInstagram />
            </a>
            <a href="https://x.com/VetrinaPune" className="social-icon">
              <FaTwitter />
            </a>
            <a href="https://www.youtube.com/channel/UCJ3r6VSr5EnxoKEQjYZoWIA" className="social-icon">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/company/14518974" className="social-icon">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/">Privacy Policy</a></li>
            <li><a href="/">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Column 3: Apps & Newsletter */}
        <div className="footer-column">
          <h4 className="footer-heading">Available On</h4>
          <div className="footer-apps">
            <img src={google} alt="Google Play" />
            <img src={iphone} alt="Apple Store" />
          </div>
          <h5 className="footer-subheading">Subscribe to Newsletter</h5>
          <form onSubmit={(e) => e.preventDefault()} className="newsletter-form">
            <input type="email" placeholder="Enter your email" required />
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        © {currentYear} Vetrina. All rights reserved. Designed & Maintained by{" "}
        <a href="https://vetrinahealthcare.com/" target="_blank" rel="noreferrer">
          Vetrina Healthcare Pvt Ltd
        </a>
      </div>
    </footer>
  );
};

export default Footer;
